var map = {
	"./avatar-1.png": "6221",
	"./avatar0.png": "7a54",
	"./avatar1.png": "b9c3",
	"./avatar2.png": "f150",
	"./avatar3.png": "fe10",
	"./avatar4.png": "894c",
	"./avatar5.png": "924c6",
	"./avatar6.png": "42d4",
	"./avatar7.png": "485ab"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "174d";